import { mapActions, mapGetters } from 'vuex'
import Utils from '@/utils/charts'

export default {
  props: {
    dataKey: {
      type: String,
      required: true
    },
    lazy: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      datasets: 'skiliko/metrics/datasets'
    }),
    datasetIdentifier () {
      return Utils.datasetIdentifier(this.dataKey, this.params)
    },
    dataset () {
      return this.datasets[this.datasetIdentifier]
    }
  },
  watch: {
    params () {
      this.fetchData()
    },
    dataset () {
      this.updateChartData()
    }
  },
  methods: {
    ...mapActions({
      fetch: 'skiliko/metrics/fetch'
    }),
    dateLabel (value) {
      return [
        value.substr(0, 4),
        value.substr(4, 2),
        value.substr(6, 2)
      ].join('-')
    },
    updateChartData () {
      if (!this.dataset) { return }
      if (!this.dataset.rows) { return }

      const chart = this._chart
      const data = this.datasetToChartData(this.dataset)

      if (!chart) {
        return this.renderChart(data, this.options)
      }
      if (!chart.data) {
        chart.destroy()
        return this.renderChart(data, this.options)
      }
      chart.data.labels = data.labels
      data.datasets.forEach((dataset, i) => {
        if (chart.data.datasets[i]) {
          Object.assign(chart.data.datasets[i], dataset)
        } else {
          chart.data.datasets[i] = dataset
        }
      })
      chart.update()
    },
    fetchData () {
      if (!this.lazy) {
        this.fetch({
          id: this.dataKey,
          params: this.params
        })
      }
      this.updateChartData()
    }
  },
  mounted () {
    this.fetchData()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/chart.js